// src/components/RaiseTicket.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './RaiseTicket.css';
   
const RaiseTicket = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    subject: '',
    description: '',
    category: 'general',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || 'https://api.jmkinfosoft.com';

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccessMessage('');

    try {
      // ✅ /api prefix सह योग्य URL
      const response = await axios.post(
        `${API_URL}/api/tickets`,
        {
          subject: formData.subject,
          description: formData.description,
          category: formData.category,
        },
        getAuthHeaders()
      );

      if (response.data.success) {
        setSuccessMessage('Ticket raised successfully!');
        setTimeout(() => {
          navigate('/user/my-tickets');
        }, 1500);
      }
    } catch (err) {
      console.error('Error creating ticket:', err);
      setError(err.response?.data?.message || 'Failed to create ticket. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBack = () => {
    navigate('/user/my-tickets');
  };

  return (
    <div className="raise-ticket-container">
      <button className="back-to-tickets-btn" onClick={handleBack}>
        <i className="fas fa-arrow-left"></i>
        Back to My Tickets
      </button>

      <div className="raise-ticket-card">
        <div className="ticket-header">
          <i className="fas fa-ticket-alt"></i>
          <h2>Raise a Ticket</h2>
          <p>Submit your query and our team will assist you</p>
        </div>

        {successMessage && (
          <div className="success-message">
            <i className="fas fa-check-circle"></i>
            {successMessage}
          </div>
        )}

        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="ticket-form">
          <div className="form-group">
            <label>
              <i className="fas fa-heading"></i>
              Subject <span className="required">*</span>
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Brief subject of your issue"
              required
            />
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-align-left"></i>
              Description <span className="required">*</span>
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Detailed description of your issue..."
              rows="6"
              required
            />
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-tag"></i>
              Category
            </label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="general">General</option>
              <option value="application">Application</option>
              <option value="payment">Payment</option>
              <option value="documents">Documents</option>
              <option value="training">Training</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={handleBack}>
              <i className="fas fa-times"></i>
              Cancel
            </button>
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Submitting...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Submit Ticket
                </>
              )}
            </button>
          </div>
        </form>

        <div className="ticket-info">
          <p>
            <i className="fas fa-clock"></i>
            Response time: 24-48 hours
          </p>
          <p>
            <i className="fas fa-phone"></i>
            For urgent issues, call: 7378707794
          </p>
        </div>
      </div>
    </div>
  );
};

export default RaiseTicket;